import { AccessibilityImages } from "../../models/AccessibilityImages";
import { a } from "../utils";

export const fetchUnitImages = (payload: AccessibilityImages[]) => a({
    type: "FETCH_UNIT_IMAGES", payload
})
export const fetchUnitImagesByProperties = (payload: AccessibilityImages[]) => a({
    type: "FETCH_UNIT_IMAGES_BY_PROPERTY", payload
})
export const fetchUnitImagesByCompanyId = (payload: AccessibilityImages[]) => a({
    type: "FETCH_UNIT_IMAGES_BY_COMPANY_ID", payload
})
export const fetchCountUnitImages = (payload: number) => a({
    type: "FETCH_COUNT_UNIT_IMAGES", payload
})
export const setLoadingUnitImages = (payload: boolean) => a({
    type: "LOADING_UNIT_IMAGES", payload
})
export const updateUnitImages = (payload: {
    index: number, response: AccessibilityImages
}) => a({
    type: "UPDATE_UNIT_IMAGE", payload
})
export const updateUnitImagesByProperty = (payload: {
    index: number, response: AccessibilityImages
}) => a({
    type: "UPDATE_UNIT_IMAGE_BY_PROPERTY", payload
})
export const deleteUnitImages = (index: number) => a({
    type: "DELETE_UNIT_IMAGE", index
})
export const deleteUnitImagesByCompanyId = (index: number) => a({
    type: "DELETE_UNIT_IMAGE_BY_COMPANY_ID", index
})
export const deleteUnitImagesByProperty = (index: number) => a({
    type: "DELETE_UNIT_IMAGE_BY_PROPERTY", index
})

export const clearCountUnitImages = () => a({
    type: "CLEAR_COUNT_UNIT_IMAGES"
})

export const clearUnitImages = () => a({
    type: "CLEAR_UNIT_IMAGES"
})

export const clearUnitImagesByCompanyId = () => a({
    type: "CLEAR_UNIT_IMAGES_BY_COMPANY_ID"
})

